import api from "api";

type GeneratePredicateParams = {
  question_text: string;
  question_id: number;
  entity_type: "question" | "question_group";
  predicate_kind: "visibility" | "requirement";
  feel_id_to_text: Record<string, string>;
  option_feel_id_to_text: Record<string, string>;
  prompt: string;
};

const apiRoot = (() => {
  const url = process.env.REACT_APP_API_URL_V2;
  if (!url) throw new Error("REACT_APP_API_URL_V2 is not set");
  return url.replace(/\/api$/, "");
})();

export const generatePredicate = async (params: GeneratePredicateParams): Promise<string> => {
  const response = await api.call("/leif-gpt/generate_predicate", {
    method: "POST",
    root: apiRoot,
    data: params,
  });
  const result = await response.json();
  return result.predicate;
};
